const TOASTER_DURATIONS = {
  transition: 400,
  timeout: 6000
};

export { TOASTER_DURATIONS };
